// actionTypes.js
export const SET_VALUE_BASE_CALCUL = "SET_VALUE_BASE_CALCUL"
export const SET_CURRENT_PAGE_BASE_CALCUL = "SET_CURRENT_PAGE_BASE_CALCUL"
export const SET_ORDER_BASE_CALCUL = "SET_ORDER_BASE_CALCUL"
export const SET_SORT_FIELD_BASE_CALCUL = "SET_SORT_FIELD_BASE_CALCUL"
export const SET_PAGE_SIZE_BASE_CALCUL = "SET_PAGE_SIZE_BASE_CALCUL"
export const SET_CUSTOM_FILTERS_BASE_CALCUL = "SET_CUSTOM_FILTERS_BASE_CALCUL"
export const SET_SORTING_BASE_CALCUL = "SET_SORTING_BASE_CALCUL"
export const SET_COLUMN_BASE_CALCUL = "SET_COLUMN_BASE_CALCUL"
//
export const SET_QUERY_BASE_CALCUL = "SET_QUERY_BASE_CALCUL"
export const SET_ACTIF_BASE_CALCUL = "SET_ACTIF_BASE_CALCUL"
export const SET_SELECTED_OPTION_FILTERS_BASE_CALCUL =
  "SET_SELECTED_OPTION_FILTERS_BASE_CALCUL"
export const SET_SELECTED_OPTION_ID_BASE_CALCUL =
  "SET_SELECTED_OPTION_ID_BASE_CALCUL"
